import React from 'react';
import { func, string } from 'prop-types';
import Button from '../button';
const NavBar = (props) => {
    const { onPreviousClick, onNextClick, className } = props;
    return (React.createElement("div", { className: className },
        React.createElement(Button, { onClick: () => onPreviousClick(), icon: "angle-left", kind: "link", theme: "dark" }),
        React.createElement(Button, { onClick: () => onNextClick(), icon: "angle-right", kind: "link", theme: "dark" })));
};
NavBar.propTypes = {
    onPreviousClick: func.isRequired,
    onNextClick: func.isRequired,
    className: string,
};
NavBar.defaultProps = {
    className: null,
};
export default NavBar;
